import { Grid, Typography, Box } from "@mui/material";

/**
 * Component for displaying the header of the Scenario View page.
 * This header includes a title and a subtitle for the Net Zero Decarbonization Model.
 * 
 * @returns {JSX.Element} The Scenario View Header component.
 */
const ScenarioViewHeader = () => {
  return (
    <Grid item xs={12} sx={{ width: '100%', maxWidth: '100%', px: 0 }}>
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center',
        width: 'calc(100vw - 320px)', 
        maxWidth: '100%' ,
      }}>
        <Box>
          <Typography
            variant="body1"
             fontSize="24px"
             fontFamily={"Inter"}
             fontWeight={700}
            sx={{
              color: "#0C0808",
              marginLeft: "6px",
            }}
            data-testid="scenarioView"
          >
            Decarbonization Plans
          </Typography>
        </Box>
      </Box>
    </Grid>
  );
};

export default ScenarioViewHeader;
